import styled from "@emotion/styled";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Modal } from "@mui/material";

const ModalContent = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "900px",
  background: "transparent",
  "@media (max-width: 600px)": {
    width: "100%",
    fontFamily: "Inter, sans-serif",
    "& .video-intro": {
      height: "250px",
    },
  },
});

const ModalClose = styled("a")({
  height: "24px",
  position: "absolute",
  top: "-36px",
  right: "12px",
  cursor: "pointer",
  color: "#FFF",
  display: "flex",
  alignItems: "center",
});

interface IProps {
  open: boolean;
  handCancel?: VoidFunction;
}
export default function ModalVideoIntro({ open, handCancel }: IProps) {
  return (
    <Modal open={open} onClose={handCancel}>
      <ModalContent style={{ outline: 0 }}>
        <ModalClose onClick={handCancel}>
          Đóng <CancelIcon sx={{ ml: 1 }}></CancelIcon>
        </ModalClose>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <iframe
            className="video-intro"
            width="90%"
            height={"475px"}
            src="https://www.youtube.com/embed/OAujCC8U9JA?si=1gzQX-h5hckCjm05&autoplay=1"
            title="YouTube video player"
            frameBorder="0"
            allow="gyroscope; fullscreen; autoplay;"
            allowFullScreen={true}
          ></iframe>
        </Box>
      </ModalContent>
    </Modal>
  );
}
